import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { LabelWithTooltip } from 'components/shared/LabelWithTooltip/LabelWithTooltip'
import { Content } from './common/Content/Content'

import styles from './Detail.module.scss'

export const Detail = ({ children, className }) => (
  <Box
    className={cx(styles.detail, { [className]: Boolean(className) })}
    direction="column"
    tagName="span"
  >
    {children}
  </Box>
)

Detail.Content = Content
Detail.LabelWithTooltip = LabelWithTooltip
